import React, { useContext } from "react";

import { Preview } from "@creatomate/preview";

import { AWSLanguage, Subtitle } from "chq";

import { CreatomateContext } from "components/stories/video-studio/contexts/VideoStudioContext";
import SubtitlesTabs from "./SubtitleTabs";
import SubtitlesLoader from "./SubtitlesLoader";
import VttParser from "./vtt/VttParser";


interface SubtitlesParserProps {
  activeLanguage?: Subtitle;
  changingLanguage: boolean;
  onLanguageChange: (subtitle: Subtitle | AWSLanguage) => void;
  preview: Preview;
}

const SubtitlesParser: React.FC<SubtitlesParserProps> = ({
  activeLanguage,
  changingLanguage,
  onLanguageChange,
  preview
}) => {
  const { data: { pendingSubtitle, subtitles } } = useContext(CreatomateContext);
  const availableSubtitles = subtitles.filter(subtitle => !subtitle.deleted);

  return (
    <div>
      <SubtitlesTabs
        activeLanguage={activeLanguage}
        changingLanguage={changingLanguage}
        onLanguageChange={onLanguageChange}
      />
      {activeLanguage?.url && (
        <VttParser preview={preview} />
      )}
      {pendingSubtitle
        && !availableSubtitles.find(subtitle => subtitle.active)?.url
        && (
          <SubtitlesLoader />
        )}
    </div>
  );
};

export default SubtitlesParser;
